import Dropdown from 'bootstrap/js/src/dropdown';
import BreakpointOnly from "./BreakpointOnly";

const classNameCartLink = 'cart-link';
const classNameCounter = 'cart-counter';
const classNameDisabled = 'disabled';
const classNameCartOpen = 'cart-open';

export default class CartWidget extends BreakpointOnly {
  constructor( breakpoint ) {

    super( breakpoint );

    this.cartButton = document.getElementById( 'show-cart' );
    if ( ! this.cartButton ) {
      return;
    }

    this.cartButtonToggle = null;
    this.cartButtonToggleEl = [].slice.call( document.querySelectorAll( '[data-bs-toggle=dropdown]' ) );
    this.closeButtons = document.querySelectorAll( '.close-cart' );
    this.widgetContainer = document.querySelector( '.cart-widget' );
    this.widgetStrategy = this.breakpoint.matches ? 'fixed' : 'absolute';

    this.addHandlers();
    this.observeCartWidget(); // Новый метод для наблюдения за изменениями
  }

  addHandlers() {
    this.cartButtonOffset( this.cartButton );
    this.cartButtonToggleHandler( this.cartButtonToggleEl );

    // Open/Close cart widget after success or finally product added to cart
    document.body.addEventListener( 'palram_open_cart_widget', this.openCartWidget.bind( this ) );
    document.body.addEventListener( 'palram_close_cart_widget', this.closeCartWidget.bind( this ) );

    if ( this.closeButtons ) {
      this.closeButtons.forEach( button => {
        button.addEventListener( 'click', this.onClickCloseButton.bind( this ) );
      } );
    }
  }

  observeCartWidget() {
    if (!this.widgetContainer) return;

    const observer = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        if (mutation.addedNodes.length || mutation.removedNodes.length) {
          this.cartWidgetMutation();
        }
      });
    });

    observer.observe(this.widgetContainer, {
      childList: true,
      subtree: true,
    });
  }

  cartButtonToggleHandler( buttons ) {
    buttons.forEach( button => {
      if ( ! button.classList.contains( classNameCartLink ) ) {
        return;
      }

      if ( ! this.cartButtonToggle ) {
        this.cartButtonToggle = new Dropdown( button, {
          popperConfig: {
            strategy: this.widgetStrategy,
          },
        } );
      }

      // button.addEventListener('click', event => {
      //     event.preventDefault();
      // });

      button.addEventListener( 'show.bs.dropdown', () => {
        document.body.classList.add( classNameCartOpen );
        this.cartWidgetContainerHeight( true );
      } );

      button.addEventListener( 'hide.bs.dropdown', () => {
        document.body.classList.remove( classNameCartOpen );
        this.cartWidgetContainerHeight( false );
      } );
    } );
  }

  onClickCloseButton( event ) {
    event.preventDefault();
    this.closeCartWidget();
  }

  openCartWidget() {
    //Fix preventing open widget after product added to cart

    if(this.cartButton.classList.contains('disabled')) {
      this.cartButton.classList.remove('disabled');
    }

    this.cartButtonToggle.show();
  }

  closeCartWidget() {
    this.cartButtonToggle.hide();
  }

  cartWidgetMutation() {
    const cartButton = document.querySelector( `.${ classNameCartLink }` );
    const countEl = document.querySelector( `.${ classNameCounter }` );
    const counter = countEl.dataset.cartCount;

    if ( counter <= 0 ) {
      this.cartButtonToggle.hide();
      if ( ! cartButton.classList.contains( classNameDisabled ) ) {
        cartButton.classList.add( classNameDisabled );
      }
      // if (palram.checkout_params.is_checkout) {
      //   window.location.reload();
      // }
    } else {
      if ( cartButton.classList.contains( classNameDisabled ) ) {
        cartButton.classList.remove( classNameDisabled )
      }

      if ( palram.checkout_params.is_checkout ) {
        $( document.body ).trigger( 'update_checkout' );
      }
    }
  }

  cartButtonOffset( button ) {
    const cartButtonOffset = this.breakpoint.matches ? '0, 20' : '20, 25';
    button.setAttribute( 'data-bs-offset', cartButtonOffset );
  }

  cartWidgetContainerHeight( open ) {
    if ( ! this.breakpoint.matches ) {
      return;
    }

    const widgetHeaderEl = document.querySelector( '.cart-widget__header' );
    const mccHeight = widgetHeaderEl.clientHeight >= '100' ? '70' : '75';
    const mccContainerEl = document.querySelector( '.mini-cart__container' );

    if ( open ) {
      mccContainerEl.setAttribute( 'style', `max-height: ${ mccHeight }vh;` );
    } else {
      mccContainerEl.removeAttribute( 'style' );
    }
  }
}

